export const propositoRelOptions = [
  { val: "Contrato de arriendo", text: "Contrato de arriendo" },
  { val: "Comodato", text: "Comodato" },
  { val: "Otro", text: "Otro" },
];
